import {EnvironmentAdmin} from 'compob2b-libs';

/**
 * Конфигурация тестового сервера, он же Staging
 */
class EnvironmentAdminTest extends EnvironmentAdmin {
  production = true;
  serviceWorkers = true;
  serverPicturesPath = 'https://tvoydom.compo-soft.ru/pictures';
  serverDocumentsPath = 'https://tvoydom.compo-soft.ru/documents';
  serverApi =  'https://tvoydom.compo-soft.ru/api/v1';
  serverUrl =  'https://tvoydom.compo-soft.ru';
  impersonate = false;
  // Корень, а не `/cabinet/dashboard` (SEO-8) — разбор в базовом `Environment.ts`.
  impersonatePortalPath = 'https://tvoydom.compo-soft.ru/';
  accessRolesCatalog = true;
  enableWorkflowButton = true;
  showDiscountPanel = true;
  featureGroupPermissions = true;
  publicShowcase = false;
  commonFeatureGroup = true;
}

export const environment = new EnvironmentAdminTest();
